import { Query } from 'graphql/generated/graphqlTypes';
import { mockDoorReader1, mockLocationTestGroup1 } from 'mocks/graphqlMocks/doorFixtures';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';

export function mockedGetVisitorsGroupsDeviceDetailsData(
  getVisitorGroupsForTenant: Query['getVisitorGroupsForTenant']
): Pick<Query, 'getVisitorGroupsForTenant'> {
  return {
    getVisitorGroupsForTenant
  };
}

export const mockedGetVisitorsGroupsDeviceDetailsDataForQuery = mockedGetVisitorsGroupsDeviceDetailsData([
  generateMockVisitorGroup({
    id: 'mockedVisitorGroupId1',
    name: 'Mock Visitor Group 1',
    accessGrants: [
      {
        id: 'mockedAccessGrantId1',
        isOfficeModeEnabled: false,
        accessSchedule: {
          __typename: 'WeekSchedule',
          weekDays: []
        },
        doorIds: [mockDoorReader1.id],
        locationIds: [mockLocationTestGroup1.id],
        locations: [{ ...mockLocationTestGroup1, doors: [mockDoorReader1] }],
        doors: [mockDoorReader1],
        name: '',
        tenantId: ''
      }
    ]
  })
]);
